// useCompositeI18n.ts
import { i18nInstance } from 'src/CrudManager/Core/Utils/i18n'
/**
 * A composable that provides a simplified translation function for components.
 *
 * @param namespace The i18n namespace for the component (e.g., 'core.NotificationCenter', 'composites.WorkDayManager')
 */
export function useCompositeI18n(namespace: string): {
  t: (key: string, params?: Record<string, unknown>) => string
} {
  const t = (key: string, params?: Record<string, unknown>) => {
    let namespacedKey = `${namespace}.${key}`

    return i18nInstance.global.t(namespacedKey, params)
  }

  return {
    t,
  }
}
